import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconBan = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,24.000 C5.383,24.000 0.000,18.617 0.000,12.000 C0.000,5.383 5.383,0.000 12.000,0.000 C18.617,0.000 24.000,5.383 24.000,12.000 C24.000,18.617 18.617,24.000 12.000,24.000 ZM2.000,12.000 C2.000,17.514 6.486,22.000 12.000,22.000 C14.398,22.000 16.600,21.150 18.325,19.738 L4.262,5.675 C2.850,7.400 2.000,9.602 2.000,12.000 ZM12.000,2.000 C9.602,2.000 7.401,2.849 5.676,4.261 L19.738,18.324 C21.150,16.599 22.000,14.397 22.000,12.000 C22.000,6.486 17.514,2.000 12.000,2.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconBan.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
